module.exports = __webpack_public_path__ + "assets/login-321c8.50f9f47.png";